/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S5_TitleInputs */

const en_landing_guide_s5_title = /** @type {(inputs: Landing_Guide_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 compared with earlier Ideogram models`)
};

const zh_landing_guide_s5_title = /** @type {(inputs: Landing_Guide_S5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ideogram 4.5 与早期 Ideogram 模型的对比`)
};

/**
* | output |
* | --- |
* | "Ideogram 4.5 compared with earlier Ideogram models" |
*
* @param {Landing_Guide_S5_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s5_title = /** @type {((inputs?: Landing_Guide_S5_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S5_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s5_title(inputs)
	return zh_landing_guide_s5_title(inputs)
});
export { landing_guide_s5_title as "landing.guide.s5_title" }